import { createContext } from 'react';

const PagesContext = createContext<any>({});

export default PagesContext;
